import { ardoizLogoGreyBlue } from "@/assets/images/brand";
import { Button } from "../../atoms/Button/Button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../../atoms/Accordion/Accordion";

type NavigationMenuProps = {
  navigationItems?: NavigationItemOrCategory[];
  footerAction?: JSX.Element;
}

type NavigationItem = {
  icon?: JSX.Element;
  title: string;
  navigate: () => void;
}

type NavigationCategory = {
  icon?: JSX.Element;
  content: NavigationItemOrCategory[];
  title: string;
}

const determineIfItemOrCategory = (toBeDetermined: NavigationItemOrCategory): toBeDetermined is NavigationItem => {
  if ((toBeDetermined as NavigationItem).navigate) {
    return true;
  }
  return false;
}

const NavigationMenu = ({ navigationItems, footerAction }: NavigationMenuProps): JSX.Element => {
  return (
    <div className="flex flex-col gap-2w py-3w items-start bg-white">
      <img
        alt="Ardoiz"
        src={ardoizLogoGreyBlue}
        width={150}
      />
      <div className="h-025v w-full bg-grey-100" />
      <nav className="flex flex-col gap-2w w-full items-start">
        {navigationItems.map((navigationItem, index) => (
          determineIfItemOrCategory(navigationItem) ? 
            <NavigationItem 
              icon={navigationItem.icon} 
              key={index} 
              title={navigationItem.title} 
              navigate={navigationItem.navigate} /> : 
            <NavigationAccordion
              icon={navigationItem.icon} 
              key={index} 
              title={navigationItem.title} 
              content={navigationItem.content} />))}
        <div className="mt-auto">
          {footerAction}
        </div>
      </nav>
    </div>);
}

const NavigationItem = ({ icon, navigate, title }: NavigationItem): JSX.Element => {
  return (<>
    <Button onClick={navigate} className="flex flex-row justify-start text-body1 text-black w-full" variant="text">
      <div className="flex w-[20px] justify-center">{icon}</div>
      {title}
    </Button></>);
}

const NavigationAccordion = ({ icon, content, title }: NavigationCategory): JSX.Element => {
  return (
    <Accordion className="w-full" type="single" collapsible>
      <AccordionItem value="item-1">
        <AccordionTrigger>
          <div className="flex w-[20px] justify-center">{icon}</div>
          {title}
        </AccordionTrigger>
        <AccordionContent className="flex flex-col gap-2w items-start">
        {content.map((navigationItem, index) => (
          determineIfItemOrCategory(navigationItem) ? 
          <NavigationItem 
            icon={navigationItem.icon} 
            key={index} 
            title={navigationItem.title} 
            navigate={navigationItem.navigate} /> : 
          <NavigationAccordion
            icon={navigationItem.icon} 
            key={index} 
            title={navigationItem.title} 
            content={navigationItem.content} />))}
        </AccordionContent>
      </AccordionItem>
    </Accordion>)
}

export type NavigationItemOrCategory = NavigationItem | NavigationCategory;
export default NavigationMenu;